import { Component, Input } from '@angular/core';
import { NumberplateScanResult } from './numberplate-scans.model';

@Component({
    selector: 'app-numberplate-scan',
    templateUrl: './numberplate-scan.component.html',
    styleUrls: ['./numberplate-scan.component.scss'],
    standalone: false
})
export class NumberPlateScanComponent {

  private scanResult_: NumberplateScanResult;

  styleClass: string;

  @Input() title: string;
  @Input() set scanResult(scanResult: NumberplateScanResult) {
    this.scanResult_ = scanResult;
    this.calculateStyle();
  }

  get scanResult() {
    return this.scanResult_;
  }

  constructor() {
  }

  private calculateStyle() {
    if (this.scanResult == null) {
      this.styleClass = '';
    } else if (this.scanResult.allowed) {
      this.styleClass = 'allowed';
    } else if (!this.scanResult.allowed) {
      this.styleClass = 'denied';
    }
  }

}
